import { useEffect, useState } from 'react'
import Navbar from '../../components/navbar/navbar'
import Select from 'react-select'
import waitingSvg from '../../assets/illustration/waiting.svg'

import EmpresasDatabaseService from '../../services/database/EmpresasDatabaseService'
import { toast } from 'react-toastify'

import ProdutosService from '../../services/database/ProdutosService'
import { CustomSpinner } from '../../components/CustomSpinner'
import { CustomButton } from '../../components/CustomButton'

import { Form, Table } from 'react-bootstrap'

import {
  Document,
  PDFDownloadLink,
  Page,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer'

import {
  ArrowLeftRight,
  EyeFill,
  EyeSlashFill,
  FiletypePdf,
  Search,
  TrashFill,
} from 'react-bootstrap-icons'

import { formatDate } from '../../utils/formatDate'

import './styles.css'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { formatPrice } from '../../utils/formatPrice'
import { CustomIntegerInput } from '../../components/CustomDecimalInput'

export function TransferenciaEstoque() {
  const [databases, setDatabases] = useState([])
  const [isLoadingDatabases, setIsLoadingDatabases] = useState(true)

  const [produtos, setProdutos] = useState([])
  const [selectedProducts, setSelectedProducts] = useState([])

  const [productSearch, setProductSearch] = useState('')
  const [bancoSaida, setBancoSaida] = useState('')
  const [bancoEntrada, setBancoEntrada] = useState('')

  const [isLoadingProdutos, setIsLoadingProdutos] = useState(false)
  const [isRequestTransferLoading, setIsRequestTransferLoading] =
    useState(false)
  const [requestHasBeenSucceed, setRequestHasBeenSucceed] = useState(false)
  const [isShowProducts, setIsShowProducts] = useState(false)

  const databasesOptions = databases.map((company) => ({
    label: company.nome_conta,
    value: company.id_conta,
  }))

  async function loadDatabases() {
    setIsLoadingDatabases(true)

    try {
      const empresasData = await EmpresasDatabaseService.getAll()

      setDatabases(empresasData)
    } catch (err) {
      console.log(`Erro ao pegar as bancos de dados da empresa: ${err}`)
      toast.error('Erro ao pegar as bancos de dados da empresa!')
    } finally {
      setIsLoadingDatabases(false)
    }
  }

  function handleQtdToTransfer(value, index) {
    const updatedProducts = [...selectedProducts]
    updatedProducts[index].quantityToTransfer = value

    setSelectedProducts(updatedProducts)
  }

  async function handleSearchProduct() {
    setIsLoadingProdutos(true)

    try {
      const produtosData = await ProdutosService.getAllToTransfer(
        bancoSaida.value,
        productSearch,
      )

      if (produtosData.length === 0) {
        toast.error('Produto não encontrado!')
      }

      setProdutos(produtosData)
      setIsShowProducts(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar os produtos!')
    } finally {
      setIsLoadingProdutos(false)
    }
  }

  function handleSelectProduct(product) {
    for (const selectedProduct of selectedProducts) {
      if (selectedProduct.codproduto === product.codproduto) {
        setProdutos((prevState) => prevState.filter((prod) => prod !== product))
        return
      }
    }

    setProdutos((prevState) => prevState.filter((prod) => prod !== product))

    setSelectedProducts((prevState) => [
      ...prevState,
      { ...product, quantityToTransfer: 0 },
    ])
  }

  function resetStates() {
    setDatabases([])
    setProdutos([])
    setSelectedProducts([])
    setProductSearch('')
    setBancoSaida('')
    setBancoEntrada('')
    setIsLoadingProdutos(false)
    setIsRequestTransferLoading(false)
    setRequestHasBeenSucceed(false)

    loadDatabases()
  }

  async function handleSubmit(e) {
    e.preventDefault()

    setIsRequestTransferLoading(true)

    try {
      for (const product of selectedProducts) {
        if (!product.precocusto) {
          return toast.error(
            `Produto com SKU ${product.sku} com preço de custo igual a 0!`,
          )
        }

        if (Number(product.qtestger) <= 0) {
          return toast.error(
            `Produto com SKU ${product.sku} possui quantidade de estoque disponível igual ou inferior á 0!`,
          )
        } else if (
          Number(product.quantityToTransfer) > Number(product.qtestger)
        ) {
          return toast.error(
            `A quantidade á transferir informada para o produto ${product.sku} é maior do que a disponível em estoque!`,
          )
        }
      }

      await ProdutosService.transferStock({
        bancoSaida,
        bancoEntrada,
        selectedProducts,
      })

      toast.success('Estoque transferido com sucesso!')

      setRequestHasBeenSucceed(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao transferir o estoque!')
    } finally {
      setIsRequestTransferLoading(false)
    }
  }

  useEffect(() => {
    loadDatabases()
  }, [])

  return (
    <>
      <Navbar />

      <form
        onSubmit={handleSubmit}
        className="m-4"
        style={{ width: '100%' }}
      >
        <div
          id="content-transfer"
          className="mt-page"
        >
          <h1>Transferência de Estoque</h1>

          <section className="inputs">
            <article>
              <div>
                <p>Selecione o banco de dados de saída</p>
                <Select
                  placeholder={
                    isLoadingDatabases
                      ? 'Carregando bancos de dados...'
                      : 'Selecione um banco'
                  }
                  value={bancoSaida}
                  isDisabled={isLoadingDatabases}
                  onChange={(option) => {
                    setBancoEntrada('')
                    setBancoSaida(option)
                    setSelectedProducts([])
                  }}
                  options={databasesOptions}
                />
              </div>

              <div>
                <p>Selecione o banco de dados de entrada</p>
                <Select
                  placeholder={
                    isLoadingDatabases
                      ? 'Carregando bancos de dados...'
                      : 'Selecione um banco'
                  }
                  value={bancoEntrada}
                  isDisabled={isLoadingDatabases}
                  onChange={(option) => {
                    setBancoEntrada(option)
                  }}
                  options={databasesOptions.filter(
                    (empresa) => empresa.value !== bancoSaida.value,
                  )}
                />
              </div>
            </article>

            <div>
              <p>Pesquise os produtos</p>

              <div style={{ display: 'flex' }}>
                <Form.Control
                  value={productSearch}
                  onChange={(e) => {
                    setProductSearch(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      handleSearchProduct()
                    }
                  }}
                  placeholder="Digite o sku ou a descrição"
                />

                <CustomButton
                  isDisabled={!bancoSaida.value || productSearch.length === 0}
                  isLoading={isLoadingProdutos}
                  onClick={handleSearchProduct}
                >
                  <Search />
                </CustomButton>
              </div>
            </div>
          </section>

          <section id="center">
            {isLoadingProdutos ? (
              <CustomSpinner />
            ) : !isLoadingProdutos && produtos.length > 0 ? (
              <div id="produtos">
                <header
                  style={{
                    height: '30px',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CustomButton
                    onClick={() =>
                      setIsShowProducts((prevState) =>
                        prevState === true ? false : true,
                      )
                    }
                    styles={{
                      position: 'absolute',
                      right: 0,
                    }}
                  >
                    {!isShowProducts ? (
                      <EyeFill size={16} />
                    ) : (
                      <EyeSlashFill size={16} />
                    )}
                  </CustomButton>
                </header>

                <div id="produtos-list">
                  {isShowProducts &&
                    produtos.map((produto) => (
                      <article
                        key={Math.random()}
                        onClick={() => handleSelectProduct(produto)}
                      >
                        <p>{produto.descricao}</p>
                      </article>
                    ))}
                </div>
              </div>
            ) : (
              !isLoadingProdutos &&
              selectedProducts.length === 0 &&
              produtos.length === 0 && (
                <img
                  src={waitingSvg}
                  style={{ width: 400 }}
                />
              )
            )}

            {!isLoadingProdutos && selectedProducts.length > 0 && (
              <>
                <div style={{ marginTop: '40px' }}>
                  <h1> Produtos Selecionados: </h1>
                  <Table
                    striped
                    bordered
                    hover
                  >
                    <thead>
                      <tr>
                        <th>Cód. Produto</th>
                        <th>SKU</th>
                        <th>Descrição</th>
                        <th>Preço Custo</th>
                        <th>Qtd do estoque</th>
                        <th>Qtd á transferir</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {console.log({ selectedProducts })}
                      {selectedProducts.map((product, index) => (
                        <tr key={product.codproduto}>
                          <td>{product.codproduto}</td>
                          <td>{product.sku}</td>
                          <td>{product.descricao}</td>
                          <td
                            style={{
                              color: product.precocusto === 0 && 'red',
                              fontWeight: product.precocusto === 0 && 'bold',
                            }}
                          >
                            {formatPrice(product.precocusto)}
                          </td>
                          <td>{product.qtestger}</td>
                          <td>
                            <CustomIntegerInput
                              required
                              maxLength="5"
                              value={selectedProducts[index].quantityToTransfer}
                              onChange={(e) => {
                                handleQtdToTransfer(e.target.value, index)
                              }}
                              style={{
                                width: 85,
                              }}
                            />
                          </td>
                          <td>
                            <CustomButton
                              color="#e50e0e"
                              onClick={() => {
                                setSelectedProducts((prevState) =>
                                  prevState.filter(
                                    (prod) => prod.sku !== product.sku,
                                  ),
                                )
                              }}
                            >
                              <TrashFill />
                            </CustomButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
          </section>

          <div
            style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              margin: '10px',
              display: 'flex',
            }}
          >
            <CustomButton
              type="submit"
              isLoading={isRequestTransferLoading}
              title="Transferir"
              isDisabled={
                selectedProducts.length === 0 ||
                !bancoSaida.value ||
                !bancoEntrada.value
              }
              color="#145a32"
            >
              <ArrowLeftRight />
            </CustomButton>

            {requestHasBeenSucceed && (
              <PDFDownloadLink
                onClick={() => {
                  setTimeout(resetStates, 2000)
                }}
                document={
                  <MyDocument
                    bancoSaida={bancoSaida.label}
                    bancoEntrada={bancoEntrada.label}
                    funcionario={localStorage.username}
                    itens={selectedProducts}
                  />
                }
                fileName="comprovante_estoque.pdf"
                style={{
                  textDecoration: 'none',
                }}
              >
                <CustomButton
                  type="button"
                  title="Baixar Comprovante"
                  color="#e55c0e"
                  style={{
                    textDecoration: 'none',
                  }}
                >
                  <FiletypePdf />
                </CustomButton>
              </PDFDownloadLink>
            )}
          </div>
        </div>
      </form>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '20px 60px',
  },
  title: {
    fontSize: 16,
    marginBottom: 20,
  },
  description: {
    fontSize: 10,
    marginBottom: 15,
    textAlign: 'center',
  },
  listItem: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  item: {
    backgroundColor: '#d2d2d2',
    width: 200,
    minHeight: 100,
    maxHeight: 100,
    padding: 10,
    margin: 10,
    borderRadius: 15,
  },
  itemText: {
    fontSize: 10,
  },
})

function MyDocument({ bancoSaida, bancoEntrada, funcionario, itens }) {
  return (
    <Document>
      <Page
        size="A4"
        style={styles.container}
      >
        <View style={styles.content}>
          <Text style={styles.title}>Transferência de Estoque</Text>
          <Text style={styles.description}>
            Uma transferência de estoque do {bancoSaida} para o {bancoEntrada}{' '}
            dos seguintes itens foi feita:
          </Text>

          <View style={styles.listItem}>
            {itens.map((item) => (
              <View
                key={item.codproduto}
                style={styles.item}
              >
                <Text style={styles.itemText}>
                  Cód. Produto: {item.codproduto}
                </Text>
                <Text style={styles.itemText}>SKU: {item.sku}</Text>
                <Text style={styles.itemText}>Descrição: {item.descricao}</Text>
                <Text style={styles.itemText}>
                  Quantidade de estoque: {item.qtestger}
                </Text>
                <Text style={styles.itemText}>
                  Quantidade transferida: {item.quantityToTransfer}
                </Text>
              </View>
            ))}
          </View>

          <Text
            style={{
              fontSize: 10,
              marginTop: 50,
            }}
          >
            Realizado por {funcionario} ás{' '}
            {formatDate(new Date(), 'dd/MM/yyyy, H:mm:ss')}
          </Text>
        </View>
      </Page>
    </Document>
  )
}
